import { AfterViewChecked, AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { PanZoomAPI, PanZoomConfig, PanZoomModel } from 'ngx-panzoom';
import { Subscription } from 'rxjs';
import { Arrays } from '../../util/arrays';
import { OrgChartDesignerComponent } from './chart-designer/chart-designer.component';
import { INode } from './node.interface';

@Component({
  selector: 'ngx-org-chart',
  templateUrl: './org-chart.component.html',
  styleUrls: ['./org-chart.component.scss']
})
export class OrgChartComponent implements AfterViewInit, OnInit, OnDestroy {

  zoomConfig: PanZoomConfig = new PanZoomConfig({zoomOnMouseWheel	: true
      , freeMouseWheel: false // 자동 휠 줌기능 (false로 하면 zommButtonIncrement 만큼 확대축소됨)
      , invertMouseWheel: true // True이면 휠상단시 줌인, 하단시 줌아웃, False이면 반대
      , zoomButtonIncrement: 0.3 // 확대, 축소 단계
      , zoomOnDoubleClick: false // 더블클릭시 확대
      , initialPanX: 10, initialPanY: 10});

  private zoomAPI: PanZoomAPI;
  private apiSubscription: Subscription;

  @Input() public set nodes(n: INode[]) {
    if (this.clickedItem != null) this.clickedItem = null;

    this.clickedItem = this.findSelectedNode(n);
    console.debug('node changes by find: ', this.clickedItem);
    this._nodes = n;
  }

  public get nodes():INode[] {
    return this._nodes;
  }

  @Input() hasParent = false;

  @Input('useSelected') useSelected: boolean = false; // 클릭 이벤트 사용여부
  @Input('useBadge') useBadge: boolean = false; // 뱃지 사용여부
  @Input('badgeField') badgeField: string = 'depth'; // 뱃지에 표시된 내용

  @Input() direction: 'vertical' | 'horizontal' = 'vertical';

  @Output() itemClick = new EventEmitter<INode>();

  private clickedItem: any = null;

  private _nodes: INode[] = [];

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    this.apiSubscription = this.zoomConfig.api.subscribe( (api: PanZoomAPI) => this.zoomAPI = api);
  }

  ngOnDestroy(): void {
    this.apiSubscription.unsubscribe();
  }

  ngAfterViewInit(): void {
    if (this.clickedItem) {
      var nodeRef = this.el.nativeElement.ownerDocument.getElementById(this.clickedItem.id);
      setTimeout(() => {this.goScroll(nodeRef)}, 300);
    } 
  }

  findSelectedNode(n: INode[]): INode {

    let result: INode = null;

    for (const node of n) {

      if (node.selected) {
        result = node;
        break;
      }
      
      if (Arrays.isNotEmpty(node.childs)) {
        result = this.findSelectedNode(node.childs);
      }

      if (result)
        break;
    }

    return result;

  }

  onItemClick(event) {

    if (!this.useSelected) {
      this.itemClick.emit(event);
      return;
    }

    if (this.clickedItem != null) {
      this.clickedItem.selected = false;
    }

    this.clickedItem = event.node;
    this.clickedItem.selected = true;
    this.itemClick.emit(event);

    this.goScroll(event.el, event.offsetLeft, event.offsetTop);

    console.debug(this.clickedItem);
    
  }

  goScroll(element: HTMLElement, offsetLeft = 0, offsetTop = 0) {
    if (!element) return;
    element.scrollIntoView({block: 'center', inline: 'center', behavior: 'smooth'});
  }
}
